/* istanbul ignore file reason: migration script */

import { StorageService } from '../storage/storage.service';
import { VaultService } from '../vault/vault.service';
import { StorageLegacyService } from './storage.service';

const MIGRATION_KEY = 'SecureStorageMigration';

export function storageMigrationFactory(storageService: StorageService, storageLegacy: StorageLegacyService, vaultService: VaultService) {
  return async () => {
    await vaultService.init();
    const encryptionKey = await vaultService.setKey();
    await storageService.create(encryptionKey);
    await vaultService.lockVault();

    const isMigrated = await storageService.get(MIGRATION_KEY);
    if (isMigrated) {
      return;
    }

    await storageLegacy.init();

    const keysFromSecureStorage = await storageLegacy.keys();

    for (const key of keysFromSecureStorage) {
      const value = await storageLegacy.get(key);
      await storageService.set(key, value);
    }

    await storageService.set(MIGRATION_KEY, true);
  };
}
